
    function parseJwt(token) {
        var base64Url = token.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join(''))
    
        return JSON.parse(jsonPayload)
    }
    
    function getCacheSuport() {
    
        let cacheSuport = localStorage.getItem("cacheSuport")
    
        return cacheSuport && JSON.parse(cacheSuport) || {}
    }

    function _getTokenAccess() {
        return localStorage.getItem('token-access')
    }

    function getParsedTokenAccess() {
        let tokenAccess = _getTokenAccess()
    
        if (!tokenAccess) {
            return null
        }
    
        return parseJwt( tokenAccess )
    }
    
    let LoginUtils = {
        saveOuthTokens({accessToken, refreshToken}) {
            localStorage.setItem('token-access', accessToken)
            localStorage.setItem('refresh-token', refreshToken)
        },
        clearTokens() {
            localStorage.removeItem('token-access')
            localStorage.removeItem('refresh-token')
        },
        getTokenAccess() {
            return _getTokenAccess()
        },
        isLogged() {
            return localStorage.getItem('token-access') != null
        },
        getLastAuthTypeUsed () {
            return localStorage.getItem('auth-type') || "TOTP"
        },
        saveLastAuthTypeUsed (authType) {
            return localStorage.setItem('auth-type', authType)
        },
        getRefreshTokenAccess() {
            return localStorage.getItem('refresh-token')
        },
        getJWT() {
            let jwt = getParsedTokenAccess()
    
            if (!jwt) {
                return null
            }
    
            return jwt
        },
        isInSecondStep() {
            let jwt = getParsedTokenAccess()
    
            if (!jwt || !jwt.authorities) {
                return false
            }
    
            return jwt.authorities.includes("ROLE_SECOND_STEP_OAUTH")
        },
        getDevice() {
            return localStorage.getItem("device")
        },
        getDeviceAndCash(login) {
            return {
                id: localStorage.getItem("device"),
                cache: getCacheSuport()[login]
            }
        },
        saveDevice(login, {device, cache}) {
            if (!device)
            {
                return;
            }
    
            if (localStorage.getItem("device") != device) {
                localStorage.removeItem("cacheSuport")
            }
    
            localStorage.setItem("device", device)
            
            let cacheSuport = getCacheSuport()
    
            cacheSuport[login] = cache
            
            localStorage.setItem("cacheSuport", JSON.stringify(cacheSuport))
        }
    }
   
export default LoginUtils